import { IUser } from 'models/IUser';

export enum UserActionTypes {
  GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS',
  EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS',
  DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS',
}
interface EditUserSuccessAction {
  type: UserActionTypes.EDIT_USER_SUCCESS;
  payload: {
    user: IUser;
  };
}

interface GetProfileSuccessAction {
  type: UserActionTypes.GET_PROFILE_SUCCESS;
  payload: {
    profile: IUser;
  };
}
interface DeleteUserSuccessAction {
  type: UserActionTypes.DELETE_USER_SUCCESS;
  payload: {
    message: string;
  };
}

export type ProfileActions =
  | EditUserSuccessAction
  | GetProfileSuccessAction
  | DeleteUserSuccessAction;
